import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Popconfirm, Spin } from "antd";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { Notification, NotificationType } from "../../models/Notification";
import { RoleType } from "../../models/Role";
import { useApplicationContext } from "../../application/ApplicationContext";
import { activeUser } from "../../services/AuthServices";
import {
  getAllNotifications,
  updateNotification,
  deleteNotification,
} from "../../services/NotificationService";
import NotificationImage from "../../assets/notification.png";
import "./NotificationListPage.scss";
import { Toast } from "primereact/toast";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";

const NotificationListPage = () => {
  const navigate = useNavigate();
  const { setBreadcrumb, setNotificationNumber } = useApplicationContext();

  const [notificationList, setNotificationList] = useState<Notification[]>([]);
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);
  const [selectedNotification, setSelectedNotification] =
    useState<Notification>();
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const toast = useRef<any>(null);

  useEffect(() => {
    setBreadcrumb(["Obaveštenja"]);
    fetchAllNotifications();
  }, []);

  const fetchAllNotifications = () => {
    setActiveSpinner(true);
    let copyOfNewNotifications: Notification[] = [];
    getAllNotifications()
      .then((response) => {
        response.data.result.map((item: any) => {
          if (
            activeUser?.role.name === RoleType.Agency &&
            item.type === NotificationType.AGENCY
          ) {
            copyOfNewNotifications.push(item);
          }
          if (
            activeUser?.role.name === RoleType.Employee &&
            item.type === NotificationType.EMPLOYEE
          ) {
            copyOfNewNotifications.push(item);
          }
          if (
            activeUser?.role.name === RoleType.Admin ||
            activeUser?.role.name === RoleType.Supervizor
          ) {
            copyOfNewNotifications.push(item);
          }
        });
        copyOfNewNotifications.sort(
          (
            firstNotification: Notification,
            secondNotification: Notification
          ) => {
            return firstNotification.seen > secondNotification.seen ? 1 : -1;
          }
        );
        setNotificationList(copyOfNewNotifications);
        const unseenNotifications = copyOfNewNotifications.filter(
          (oneNotification: Notification) => oneNotification.seen === false
        );
        setNotificationNumber(unseenNotifications.length);
      })
      .finally(() => setActiveSpinner(false))
      .catch((err) => console.log(err));
  };

  const handleNotificationView = (newSelectedNotification: Notification) => {
    setOpenViewModal(true);
    setSelectedNotification(newSelectedNotification);
    if (
      activeUser?.role.name === RoleType.Agency ||
      activeUser?.role.name === RoleType.Employee
    ) {
      updateNotification(newSelectedNotification.id as string, {
        ...newSelectedNotification,
        seen: true,
      }).then(() => fetchAllNotifications());
    }
  };

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <div className="notification-list-container">
        <Spin spinning={activeSpinner}>
          {notificationList.map((notificationItem: Notification) => {
            return (
              <div
                key={notificationItem.id}
                className="notification-item-container"
              >
                <div className="details-item-container">
                  <img className="image" alt="" src={NotificationImage} />
                  <div onClick={() => handleNotificationView(notificationItem)}>
                    <p
                      className={`${
                        notificationItem.seen === false
                          ? "details-item-title-active"
                          : "details-item-title"
                      }`}
                    >
                      {notificationItem.title}
                    </p>
                    <p
                      className={`${
                        notificationItem.seen === false
                          ? "details-item-active"
                          : "details-item"
                      }`}
                    >
                      {notificationItem.content}
                    </p>
                  </div>
                </div>
                <div className="actions-item-container">
                  <Popconfirm
                    title="Brisanje notifikacije?"
                    description="Da li ste sigurni da želite da izbrišete notifikaciju?"
                    onConfirm={() => {
                      setActiveSpinner(true);
                      deleteNotification(notificationItem.id as string)
                        .then(() => {
                          toast?.current?.show({
                            severity: "success",
                            detail: "Uspešno izbrisana notifikacija",
                            life: 3000,
                          });
                          fetchAllNotifications();
                        })
                        .finally(() => setActiveSpinner(false))
                        .catch((err) => console.log(err));
                    }}
                    onCancel={() => {}}
                    okText="Da"
                    cancelText="Ne"
                  >
                    {activeUser?.role.name === RoleType.Admin && (
                      <span className="action-item">Brisanje</span>
                    )}
                  </Popconfirm>
                  <span
                    className="action-item"
                    onClick={(e) => handleNotificationView(notificationItem)}
                  >
                    Pregled
                  </span>
                </div>
              </div>
            );
          })}
          <Modal
            maskClosable={false}
            open={openViewModal}
            title={`${selectedNotification?.title}`}
            onCancel={() => setOpenViewModal(false)}
            onOk={() => setOpenViewModal(false)}
            footer={[
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={1}
                type={"primary"}
                function={() => {
                  if (selectedNotification?.isCompanyRegistration === true) {
                    setOpenViewModal(false);
                    navigate(
                      `/edit-registration-company/${selectedNotification.registrationId}`,
                      {
                        state: {
                          edit: true,
                        },
                      }
                    );
                  } else {
                    setOpenViewModal(false);
                    navigate(
                      `/edit-registration/${selectedNotification?.registrationId}`,
                      {
                        state: {
                          edit: true,
                        },
                      }
                    );
                  }
                }}
                text={"Pogledaj prijavu"}
              />,
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={2}
                type={"primary"}
                function={() => setOpenViewModal(false)}
                text={"Zatvori"}
              />,
            ]}
          >
            <p className="notification-content">{`${selectedNotification?.content}`}</p>
          </Modal>
        </Spin>
      </div>
    </PageLayout>
  );
};

export default NotificationListPage;
